module.exports = __webpack_public_path__ + "img/ico_saludable.85b5ee85.svg";